export const iconFontAwesomeScienceTablets = (
	<i className="fa-solid fa-tablets"></i>
);
